import { FormEvent } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useObjectPropertyCreate } from '../api/object-properties'
import { ObjectPropertiesForm } from './object-properties-form'

export function ObjectPropertiesCreate({ kind }: { kind?: string }) {
	const { object = kind } = useParams<{ object: string }>()
	if (!object) throw new Error('Invalid invocation')
	const navigate = useNavigate()
	const { mutate, isPending } = useObjectPropertyCreate()

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form), {
			onSuccess: () => {
				form.reset()
				navigate('../')
			},
		})
	}

	return <ObjectPropertiesForm object={object} onSubmit={onSubmit} isPending={isPending} />
}
